import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import * as sx from '../common/stylesInline/report_daily_branch'
import DropDownOA from '../common/dropDownOA'
import { Item } from '../common/snippets'
import LineinputV2 from '../common/lineinputV2'
import Datepicker from '../common/datePicker'
import { selectPaymentModeOpt } from '../common/constants'
import { clickElement, focusElemnt, isEmpty, navigation1, navigation3, uploadToS3 } from '../common/helper'
import { connect } from 'react-redux'
import {  getPartyList, updateAlertError } from '../../store/common/common_action'
import { getBranchRecharge } from '../../store/booking/booking_action'
import moment from 'moment'
import FileInput from '../common/fileInput'
import SuccessAndErrorModal from '../common/SuccessAndErrorModal'
import Lineinput from '../common/lineinput'
import { useTranslation } from '../../i18n/I18nProvider'
const PartyRecharge = (props) => {
    const { translations } = useTranslation()
    const cs = translations?.common || {}
    const rh = translations?.recharge || {}
    const { data,  getBranchRecharge, updateAlertError, getPartyList, updateModal,cargoBalance, companySettings } = props
    const { common} = data
    const { loginData, partyList, RechargePaymentList } = common
    let labelAmt = [
        '',
        rh.amountDeposited || 'Amount Deposited',
        rh.chequeNo || 'Cheque No.',
        rh.demandDraftNo || 'Demand Draft No.',
        rh.transactionRefNo || 'Transaction Ref No',
        rh.transactionRefNo || 'Transaction Ref No',
        rh.amountDeposited || 'Amount Deposited',
    ]
    let labelDate = [
        '',
        rh.depositDate || 'Deposit Date',
        rh.chequeDate || 'Cheque Date',
        rh.depositDate || 'Deposit Date',
        rh.transactionDate || 'Transaction Date',
        rh.transactionDate || 'Transaction Date',
        rh.depositDate || 'Deposit Date',
    ]
    const [selPaymentMode, setSelPaymentMode] = useState([])
    const [paymentModeList, setPaymentModeList] = useState([])
    const [filters, setFilters] = useState({
        partyhName: '', currentBalance: 0, paymentMode: '', rechargeAmount: 0,
        processingFee: 0, amountToBePaid: 0, bankName: '', beneficiaryAccNo: '', instrumentNo: '', depositDate: moment(new Date()), instrumentDate: moment(new Date())
    })
    const [fileData, setFileData] = useState(null)
    const [isSuccess, setIsSuccess] = useState(false)
    const [resetFileInput, setResetFileInput] = useState(false);
    const MaxFileSize = 10 * 1024 * 1024 //10MB
    // const [isFocused, setIsFocused] = useState(false);
    // const handleFocus = () => setIsFocused(true);
    // const handleBlur = () => setIsFocused(false);
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        focusElemnt('select_Payment_Mode')
    }, [])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const obj = {
                intPartyID: 0,
                intCompanyID: loginData?.intCompanyID,
                strPartyName: '',
                strContactPerson: '',
                intCityID: 0,
                intIsCreditParty: 0,
                intIsActive: -1,
                intIsDeleted: 0,
            }
            getPartyList(obj)
        }
    }, [loginData])
    useEffect(() => {
        if (partyList?.length > 0) {
            setFilters((prev) => ({
                ...prev,
                partyhName: partyList?.[0]
            }))
        }
    }, [partyList])
  
    useEffect(() => {
        if (RechargePaymentList?.length > 0) {
            setPaymentModeList(RechargePaymentList)
            setSelPaymentMode(RechargePaymentList[0])
            setFilters((prev) => ({
                ...prev,
                paymentMode: RechargePaymentList[0],
                instrumentNo:0
            }))
        }
    }, [RechargePaymentList])
    useEffect(() => {
        if (fileData) {
          const allowedExtensions = ['.pdf', '.jpeg', '.jpg'];
          const fileExtension = fileData.name.substring(fileData.name.lastIndexOf('.'));
          if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
            updateAlertError({ show: true, msg: rh.onlyPdfJpegJpgAllowed || `Only PDF, JPEG Or JPG files are allowed`, nextId: '' })
            setFileData(null)
            setResetFileInput(!resetFileInput)
          } else if (fileData.size > MaxFileSize) {
            updateAlertError({ show: true, msg: rh.fileSizeCannotBeMoreThan10Mb || `The size of the file being uploaded cannot be more than 10 MB`, nextId: '' })
            setFileData(null)
                setResetFileInput(!resetFileInput)
          } else {
            setResetFileInput(false)
          }
        }
      }, [fileData]);
    const handleSave = async () => {
        if (filters?.partyhName === '') {
            updateAlertError({ show: true, msg: rh.pleaseSelectThePartyName || 'Please Select The Party Name', nextId: 'branch_name' })
        } else if (filters?.rechargeAmount === 0) {
            updateAlertError({ show: true, msg: rh.pleaseEnterTheRechargeAmount || 'Please Enter The Recharge Amount', nextId: 'recharge_Amount' })
        } else if (filters?.bankName === '') {
            updateAlertError({ show: true, msg: rh.pleaseEnterTheBankName || 'Please Enter The Bank Name', nextId: 'bank_Name' })
        } else if ((selPaymentMode?.RechargePaymentModeID!==1|| selPaymentMode?.RechargePaymentModeID!==6) && filters?.instrumentNo === '') {
            updateAlertError({ show: true, msg: (rh.pleaseEnterTheLabel || 'Please Enter The {label}').replace('{label}', labelAmt[selPaymentMode?.RechargePaymentModeID]), nextId: 'labelAmt' })
        } else if((selPaymentMode?.RechargePaymentModeID === 2||selPaymentMode?.RechargePaymentModeID === 3) && filters?.instrumentNo?.length<6){
            updateAlertError({ show: true, msg: (rh.labelMustHaveAtleast6Characters || '{label} Must Have Atleast 6 Characters').replace('{label}', labelAmt[selPaymentMode?.RechargePaymentModeID]) , nextId: 'labelAmt' })
        }else if((selPaymentMode?.RechargePaymentModeID === 2||selPaymentMode?.RechargePaymentModeID === 3) && filters?.instrumentNo?.length>6){
            updateAlertError({ show: true, msg: (rh.labelCannotHaveMoreThan6Characters || '{label} Cannot Have More Than 6 Characters').replace('{label}', labelAmt[selPaymentMode?.RechargePaymentModeID]) , nextId: 'labelAmt' })
        }else if(selPaymentMode?.RechargePaymentModeID === 4 && filters?.instrumentNo?.length<12){
            updateAlertError({ show: true, msg: (rh.labelCannotHaveLessThan12Characters || '{label} Cannot Have Less Than 12 Characters').replace('{label}', labelAmt[selPaymentMode?.RechargePaymentModeID]) , nextId: 'labelAmt' })
        }else if(selPaymentMode?.RechargePaymentModeID === 5 && filters?.instrumentNo?.length<16){
            updateAlertError({ show: true, msg: (rh.labelCannotHaveLessThan16Characters || '{label} Cannot Have Less Than 16 Characters').replace('{label}', labelAmt[selPaymentMode?.RechargePaymentModeID]) , nextId: 'labelAmt' })
        }else if (companySettings?.IsUploadRchTxnReceipt===1 && fileData === null) {
            updateAlertError({ show: true, msg: rh.pleaseUploadTheTransactionReceipt || `Please Upload The Transaction Receipt`, nextId: '' })
        }else {
            try {
                const url = fileData!==null?await uploadToS3(fileData, 'Party_Recharge_TransReceipt'):''
                let obj = {
                    intUserID: loginData?.intUserID,
                    intCompanyID: loginData?.intCompanyID,
                    intBranchID: 0,
                    dcmAmount: filters?.rechargeAmount,
                    intRechargePaymentModeID: selPaymentMode?.RechargePaymentModeID,
                    strBankName: filters?.bankName,
                    strInstrumentNo: filters?.instrumentNo?.toString(),
                    dtInstrumentDate: filters?.instrumentDate,
                    AmountDeposited: 0,
                    DepoisteDate: filters?.depositDate,
                    TransReceipt: url,
                    intPartyID: filters?.partyhName?.PartyID
                };

                const res = await getBranchRecharge(obj);
                if (res.status && res?.Data?.Table?.[0]?.hasOwnProperty('RechargeID')) {
                    setIsSuccess(true)
                } else {
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
                }
            } catch (err) {
                updateAlertError({ show: true, msg: err, nextId: '' })
            }
        }
    }
   
    return (
        <>
            <Box className='reportButton' >
                <Grid container sx={{ padding: '12px' }}>
                    <Grid item md={2.8}>
                        <Item>
                            <DropDownOA
                                id={'branch_name'}
                                label={rh.selectPartyName || 'Select Party Name'}
                                data={partyList}
                                defaultvalue={filters?.partyhName?.Party}
                                idKey={`PartyID`}
                                dataKey={`Party`}
                                onSelect={(val) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        partyhName: val
                                    }))
                                }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <LineinputV2
                                label={rh.currentBalance || 'Current Balance'}
                                id={'current_balance'}
                                disabled={true}
                                value={cargoBalance}
                                onBlur={(e) => { }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item>
                            <DropDownOA
                                id={'select_Payment_Mode'}
                                label={rh.selectPaymentMode || 'Select Payment Mode'}
                                defaultvalue={selPaymentMode?.RechargePaymentModeName}
                                value={selPaymentMode?.RechargePaymentModeName}
                                data={paymentModeList || []}
                                idKey={`RechargePaymentModeID`}
                                dataKey={`RechargePaymentModeName`}
                                onSelect={(val) => {
                                    setSelPaymentMode(val)
                                    setFilters((prev)=>({
                                        ...prev,
                                        instrumentNo: val?.RechargePaymentModeID === 1||val?.RechargePaymentModeID === 6?0:''
                                    }))
                                }}
                                nextId={'recharge_Amount'}
                                prevId={'RechargeBtn'}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            
                            <Lineinput
                                label={rh.rechargeAmount || 'Recharge Amount'}
                                id={'recharge_Amount'}
                                value={filters?.rechargeAmount}
                                onChange={(e) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        rechargeAmount: Number(e.target.value.replace(/[^\d]/g, '')),
                                        amountToBePaid: Number(e.target.value.replace(/[^\d]/g, '')) + prev?.processingFee
                                    }))
                                }}
                                onKeyDown={(e) => {
                                    navigation1(e, selPaymentMode?.RechargePaymentModeID === 7 ? 'generateOR' : 'bank_Name', 'select_Payment_Mode')
                                }}
                            />
                        </Item>
                    </Grid>
                    {/* <Grid item md={1.9}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <LineinputV2
                                label={rh.processingFees || 'Processing Fees'}
                                id={'processing_Fees'}
                                value={filters?.processingFee}
                                onBlur={(e) => { }}
                                disabled={true}
                            />
                        </Item>
                    </Grid> */}
                    <Grid item md={2.3}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <LineinputV2
                                label={rh.amountToBePaid || 'Amount To be Paid'}
                                id={'amount_To_be_Paid'}
                                value={filters?.amountToBePaid}
                                onBlur={(e) => { }}
                                disabled={true}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.8}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <LineinputV2
                                label={rh.bankName || 'Bank Name'}
                                id={'bank_Name'}
                                value={filters?.bankName}
                                onBlur={(e) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        bankName: e.target.value
                                    }))
                                }}
                                onKeyDown={(e) => {
                                    navigation1(e, 'labelAmt', 'recharge_Amount')
                                }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                                label={labelAmt[selPaymentMode?.RechargePaymentModeID]}
                                id={'labelAmt'}
                                value={filters?.instrumentNo}
                                maxLength={selPaymentMode?.RechargePaymentModeID === 2 || selPaymentMode?.RechargePaymentModeID === 3 ? 6 : selPaymentMode?.RechargePaymentModeID === 4 ? 22 : selPaymentMode?.RechargePaymentModeID === 5 ? 16 : 1}
                                disabled={selPaymentMode?.RechargePaymentModeID === 1 || selPaymentMode?.RechargePaymentModeID === 6}
                                onChange={(e) => {
                                    if (selPaymentMode?.RechargePaymentModeID === 1 || selPaymentMode?.RechargePaymentModeID === 2 || selPaymentMode?.RechargePaymentModeID === 3) {
                                        setFilters((prev) => ({
                                            ...prev,
                                            instrumentNo: Number(e.target.value.replace(/[^\d]/g, '')),
                                        }))
                                    } else if (selPaymentMode?.RechargePaymentModeID === 4 || selPaymentMode?.RechargePaymentModeID === 5) {
                                        setFilters((prev) => ({
                                            ...prev,
                                            instrumentNo: e.target.value
                                        }))
                                    }
                                }}
                                onKeyDown={(e) => {
                                    navigation1(e, 'labelDate', 'bank_Name')
                                }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item className="input--container bookingDatePicker">
                            <Datepicker
                                label={labelDate[selPaymentMode?.RechargePaymentModeID]}
                                width="100%"
                                name={'labelDate'}
                                id={'labelDate'}
                                value={filters?.depositDate}
                                dateChange={(date) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        depositDate: date
                                    }))
                                    focusElemnt('file-input-item')
                                }}
                            />
                        </Item>
                    </Grid>
                    <Grid item md={2.3}>
                        <Item className="input--container bookingDatePicker">
                            <Datepicker
                                label={rh.instrumentDate || 'Instrument Date'}
                                width="100%"
                                name={'instrument_Date'}
                                id={'instrument_Date'}
                                value={filters?.instrumentDate}
                                statusChecked={true}
                                dateChange={(date) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        instrumentDate: date
                                    }))
                                }}
                            />
                        </Item>
                    </Grid>
                </Grid>

                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: "16px" }}>
                    <Box sx={sx.itemsx}>
                        <Item >
                            <Box style={{ display: "flex", alignItems: "center", fontWeight: "500", fontSize: "14px", color: '#444' }}>
                                {rh.uploadTransactionReceipt || 'Upload Transaction Receipt :(Format : PDF,JPG)'}
                            </Box>
                        </Item>
                        <Item sx={{ display: 'flex', flexDirection: 'column', marginTop: '14px !important', width: '300px' }} className="disabled-wrapper">
                            <div id={'file-input-item'} tabIndex={0}
                                style={{
                                    // border: isFocused ? '2px solid red' : '2px solid transparent',
                                    padding: '0px', margin: '0px', borderRadius: '6px'
                                }}
                                // onFocus={handleFocus}
                                // onBlur={handleBlur}
                                onKeyDown={(e) => navigation3(e, "CANCEL", 'labelDate', () => { clickElement('chooseFileInput') })}
                            >
                            <FileInput id={'chooseFileInput'} width={`300px`} label={rh.chooseFile || 'Choose File'} fileChange={setFileData} accept={".jpeg, .pdf"} value={''}  maxFileSize={10485760}
                                onKeyDown={(e) => navigation3(e, 'uploadBtn', 'rateSampleBtn', () => { })}
                            />
                            </div>
                            <span style={{ color: '#FE5200', fontSize: '12px' }}>{rh.fileMustNotExceed10Mb || '* File must not exceed 10 MB'}</span>
                        </Item>
                    </Box>
                    <Box sx={sx.itemsx}>
                        <Item className="disabled-wrapper" >
                            <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                                onClick={() => { updateModal() }}
                                onKeyDown={(e) => {
                                    navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                }}>
                                {rh.cancel || 'CANCEL'}
                            </Button>
                        </Item>
                        <Item className="disabled-wrapper" >
                            <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                                onClick={() => { handleSave() }}
                                onKeyDown={(e) => {
                                    navigation1(e, 'select_Payment_Mode', 'CANCEL')
                                }}
                            >
                                {rh.rechargeRequest || 'Recharge REQUEST'}
                            </Button>
                        </Item>
                    </Box>
                </Box>

            </Box>
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); updateModal(); focusElemnt('') }} open={isSuccess} title={(cs.rechargeRequestSubmittedSuccessfullyOfRs || 'Recharge Request Submitted\nSuccessfully of Rs {amount}').replace('{amount}', filters?.amountToBePaid)} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
     getBranchRecharge, updateAlertError, getPartyList
}
export default connect(mapStateToProps, mapDispatchToProps)(PartyRecharge)